export default __webpack_public_path__ + "static/media/logout.d3186f75.svg";